export default "__VITE_ASSET__DxcvP_KL__"